<!-- SPDX-License-Identifier: AGPL-3.0-only -->

<script setup lang="ts">
export type NavigationIconName =
  | "dashboard"
  | "tenants"
  | "users"
  | "tiers"
  | "overview"
  | "probe"
  | "members"
  | "notifications"
  | "settings"
  | "account"
  | "collapse";

interface NavigationIconProperties {
  readonly name: NavigationIconName;
}

defineProps<NavigationIconProperties>();
</script>

<template>
  <svg class="navigation-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      v-if="name === 'dashboard'"
      d="M4 13h6V4H4v9Zm0 7h6v-4H4v4Zm10 0h6v-9h-6v9Zm0-16v4h6V4h-6Z"
    />
    <path
      v-else-if="name === 'tenants'"
      d="M4 20V7l8-4 8 4v13M8 20v-3h8v3M8 9h2m4 0h2m-8 4h2m4 0h2"
    />
    <path
      v-else-if="name === 'users'"
      d="M16 20v-1.5c0-2.5-2.2-4.5-5-4.5s-5 2-5 4.5V20m5-9a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm5-1a3 3 0 0 1 2 5.2c1.2.8 2 2.1 2 3.8v1"
    />
    <path
      v-else-if="name === 'tiers'"
      d="M4 7h16M6 7V4h12v3M5.5 12h13M7.5 12V9h9v3M7 17h10M9 17v-3h6v3M10 21h4v-4h-4v4Z"
    />
    <path
      v-else-if="name === 'overview'"
      d="M4 12 12 5l8 7M6.5 10.5V20h11v-9.5M10 20v-5h4v5"
    />
    <path
      v-else-if="name === 'probe'"
      d="M7 5.5h10A2.5 2.5 0 0 1 19.5 8v8a2.5 2.5 0 0 1-2.5 2.5H7A2.5 2.5 0 0 1 4.5 16V8A2.5 2.5 0 0 1 7 5.5Zm2 4h6m-6 4h3m5-1.5h2.5m-15 0H2M12 3v2.5m0 13V21"
    />
    <path
      v-else-if="name === 'members'"
      d="M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm7-1a3 3 0 1 0 0-6m-7 10c-3 0-5.5 2-5.5 4.5V20h11v-1.5C14.5 16 12 14 9 14Zm7-1c2.5 0 4.5 1.7 4.5 4V20h-3"
    />
    <path
      v-else-if="name === 'notifications'"
      d="M18 16v-5a6 6 0 0 0-12 0v5l-2 2h16l-2-2ZM10 20a2 2 0 0 0 4 0"
    />
    <path
      v-else-if="name === 'settings'"
      d="M12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm7.2 3.5c0-.5-.1-1-.2-1.5l2-1.5-2-3.4-2.5 1a8 8 0 0 0-2.5-1.5L13.7 2h-4L9.3 5.1a8 8 0 0 0-2.5 1.5l-2.5-1-2 3.4 2 1.5a8 8 0 0 0 0 3l-2 1.5 2 3.4 2.5-1a8 8 0 0 0 2.5 1.5l.4 3.1h4l.4-3.1a8 8 0 0 0 2.5-1.5l2.5 1 2-3.4-2-1.5c.1-.5.1-1 .1-1.5Z"
    />
    <path
      v-else-if="name === 'account'"
      d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 8c0-3.3 3.1-6 7-6s7 2.7 7 6"
    />
    <path v-else d="m14.5 6-6 6 6 6" />
  </svg>
</template>
